import * as graphql from 'generated/graphql';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';

export default function useSupportedLanguageIDs(): string[] | undefined {
	const workspace = useWorkspace();
	const query = graphql.useSupportedLanguagesQuery({
		variables: { id: workspace.id },
		fetchPolicy: 'cache-first',
	});

	return query.data?.workspace.supportedLanguageIDs ?? ['nl_NL', 'en_US'];
}
